/* eslint-disable @angular-eslint/directive-selector */
import { Directive } from '@angular/core';

@Directive({
  selector: 'zef-form-label',
  standalone: false
})
export class ZefFormLabelDirective { }
